import React from "react";
import { GET } from "lib/api";
import config from "lib/config";
import _ from "lodash";
import { IconButton } from "lib/components/Button";
import Tabs from "Components/Fragment/Tabs";

import LuvitComponent from "LuvitComponent";
import Overview from "./surveytrackingoverview";

export default class SurveyTracking extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Progress");
  }

  async componentWillMount() {
    let surveys;
    let users;
    let params = {
      showInactiveUsers: false,
      hideCompleted: true,
      filter: "",
      personalId: config.personalId,
    };

    if (luvit.GetQueryString("courseid")) {
      surveys = await GET("v1/education/tracking/surveys/:courseId", {
        courseId: luvit.GetQueryString("courseid"),
      });

      const urlWithParameters = `v1/education/tracking/surveys/:courseId/userstatus?${new URLSearchParams(
        params,
      )}`;

      users = await GET(urlWithParameters, {
        courseId: luvit.GetQueryString("courseid"),
      });
    }

    this.setState({
      ready: true,
      surveys,
      users,
      showInactiveUsers: false,
      hideCompleted: true,
    });
  }

  setSearchText(searchText) {
    this.setState({ searchText });
  }

  clearSearch() {
    if (this.state.searchText === "") {
      return;
    }

    this.setState({ searchText: "" });
    this.doSearch(true);
  }

  async doSearch(clear) {
    let searchText = this.state.searchText;
    if (!searchText || clear) {
      searchText = "";
      this.setState({ searchText: "" });
    }

    let params = {
      showInactiveUsers: this.state.showInactiveUsers,
      hideCompleted: this.state.hideCompleted,
      filter: searchText,
      personalId: config.personalId,
    };

    const urlWithQueryParameters = `v1/education/tracking/surveys/:courseId/userstatus?${new URLSearchParams(
      params,
    )}`;
    let users = await GET(urlWithQueryParameters, {
      courseId: luvit.GetQueryString("courseid"),
    });

    this.setState({ users });
    return false;
  }

  handleEnterKey(event) {
    if (event.key == "Enter") {
      this.doSearch();
    }
  }

  toggleHideCompleted() {
    this.setState({ hideCompleted: !this.state.hideCompleted }, () =>
      this.doSearch(),
    );
  }

  toggleShowInactive() {
    this.setState({ showInactiveUsers: !this.state.showInactiveUsers }, () =>
      this.doSearch(),
    );
  }

  doRender() {
    if (!this.state || !this.state.ready) {
      return <div> Loading... </div>;
    }
    let users = this.state.users.map(function (u) {
      let noOfDocs =
        u.noOfCompleted +
        u.noOfNotAttempted +
        u.noOfIncomplete +
        u.noOfPending +
        u.noOfFailed +
        u.noOfPassed;

      let noOfCompletedWidth =
        Math.round((u.noOfCompleted / noOfDocs) * 100) + "%";
      let noOfCompleted = (
        <div className="part completed" style={{ width: noOfCompletedWidth }}>
          {u.noOfCompleted}
        </div>
      );

      let noOfNotAttemptedWidth =
        Math.round((u.noOfNotAttempted / noOfDocs) * 100) + "%";
      let noOfNotAttempted = (
        <div
          className="part notattempted"
          style={{ width: noOfNotAttemptedWidth }}
        >
          {u.noOfNotAttempted}
        </div>
      );

      let noOfIncompleteWidth =
        Math.round((u.noOfIncomplete / noOfDocs) * 100) + "%";
      let noOfIncomplete = (
        <div className="part incomplete" style={{ width: noOfIncompleteWidth }}>
          {u.noOfIncomplete}
        </div>
      );

      let noOfPendingWidth = Math.round((u.noOfPending / noOfDocs) * 100) + "%";
      let noOfPending = (
        <div className="part pending" style={{ width: noOfPendingWidth }}>
          {u.noOfPending}
        </div>
      );

      let noOfFailedWidth = Math.round((u.noOfFailed / noOfDocs) * 100) + "%";
      let noOfFailed = (
        <div className="part failed" style={{ width: noOfFailedWidth }}>
          {u.noOfFailed}
        </div>
      );

      let noOfPassedWidth = Math.round((u.noOfPassed / noOfDocs) * 100) + "%";
      let noOfPassed = (
        <div className="part passed" style={{ width: noOfPassedWidth }}>
          {u.noOfPassed}
        </div>
      );

      let noOfSurveys = u.noOfAnsweredSurveys + u.noOfNotAnsweredSurveys;
      let noOfAnsweredSurveysWidth = Math.round(
        (u.noOfAnsweredSurveys / noOfSurveys) * 100,
      );
      let noOfNotAnsweredSurveysWidth = 100 - noOfAnsweredSurveysWidth;
      noOfAnsweredSurveysWidth += "%";
      noOfNotAnsweredSurveysWidth += "%";

      return (
        <tr key={u.personalId}>
          <td> {u.firstName}</td>
          <td> {u.lastName}</td>
          <td>
            <div className="docstatus">
              {u.noOfAnsweredSurveys > 0 && (
                <div
                  className="part completed"
                  style={{ width: noOfAnsweredSurveysWidth }}
                >
                  {u.noOfAnsweredSurveys}
                </div>
              )}
              {u.noOfNotAnsweredSurveys > 0 && (
                <div
                  className="part notattempted"
                  style={{ width: noOfNotAnsweredSurveysWidth }}
                >
                  {u.noOfNotAnsweredSurveys}
                </div>
              )}
            </div>
          </td>
          <td style={{ display: "none" }}>
            <div className="docstatus">
              {u.noOfCompleted > 0 && noOfCompleted}
              {u.noOfPassed > 0 && noOfPassed}
              {u.noOfPending > 0 && noOfPending}
              {u.noOfIncompleted > 0 && noOfIncomplete}
              {u.noOfFailed > 0 && noOfFailed}
              {u.noOfNotAttempted > 0 && noOfNotAttempted}
            </div>
          </td>
          <td style={{ display: "none" }} className="nowrap">
            {" "}
            {u.completed && (
              <span>
                <i className="icon-check" aria-hidden="true" />
              </span>
            )}
            {u.completed && " (" + u.completedDate + ")"}
          </td>
        </tr>
      );
    });

    const participantsComponent = (
      <>
        <div className="flex align-c surveystatussearch">
          <div className="flex relative">
            <input
              type="text"
              placeholder={this.l("search")}
              aria-label={this.l("search")}
              value={this.state.searchText}
              onChange={(e) => this.setSearchText(e.target.value)}
              onKeyPress={(e) => this.handleEnterKey(e)}
              className="input-search"
            />
            <IconButton
              icon={this.state.searchText ? "icon-close" : "hidden"}
              onClick={() => {
                this.clearSearch();
              }}
              label={this.l("close")}
            />
            <IconButton
              icon={this.state.searchText ? "hidden" : "icon-search"}
              onClick={() => {
                this.doSearch();
              }}
              label={this.l("search")}
            />
            <div className="flex align-c">
              <input
                type="checkbox"
                id="ChkHideCompleted"
                title={this.l("hidecompleted")}
                defaultChecked={this.state.hideCompleted}
                onChange={this.toggleHideCompleted.bind(this)}
              />
              <label htmlFor="ChkHideCompleted">
                {this.l("hidecompleted")}
              </label>
              &nbsp;&nbsp;
              <input
                type="checkbox"
                id="ChkHideInactive"
                title={this.l("hideinactiveusers")}
                defaultChecked={!this.state.showInactiveUsers}
                onChange={this.toggleShowInactive.bind(this)}
              />
              <label htmlFor="ChkHideInactive">
                {this.l("hideinactiveusers")}
              </label>
            </div>
          </div>
        </div>
        <table className="maindatatable basic morepadding">
          <thead>
            <tr>
              <th>{this.l("firstname")}</th>
              <th>{this.l("lastname")}</th>
              <th>{this.l("surveystatus")}</th>
            </tr>
          </thead>
          <tbody>{users}</tbody>
        </table>
      </>
    );

    const tabs = [
      {
        label: this.l("overview"),
        content: <Overview surveys={this.state.surveys} />,
      },
      {
        label: this.l("participants"),
        content: participantsComponent,
      },
    ];

    return (
      <div
        className={this.props.type === "simple" ? "panel-heading" : "tracking"}
      >
        <h3
          className={
            this.props.type === "simple"
              ? "panel-heading row flex-space-b"
              : "page-header"
          }
        >
          {this.l("surveys")}
        </h3>
        <br />
        <Tabs tabs={tabs} />
      </div>
    );
  }
}
